import { Outlet } from "react-router-dom"
const MainProgress = () =>{

    return(
        <div className=" w-full h-full">
         <Outlet/>
        </div>
    )
}


export default MainProgress;